import { API_BASE_URL } from '../config';
import { getImageUrl } from '../services/api';

export interface WorkoutStretchingContentItem {
  title: string;
  description: string;
  imageUrl: string;
  alt: string;
  displayOrder: number;
}

export interface ResolvedWorkoutStretchingContentItem extends WorkoutStretchingContentItem {
  safeImageUrl: string | null;
}

type StretchingOverrideWindow = typeof globalThis & {
  __WORKOUT_STRETCHING_CONTENT__?: WorkoutStretchingContentItem[] | null;
};

export const WORKOUT_STRETCHING_CONTENT: WorkoutStretchingContentItem[] = [
  {
    title: 'Разтягане за гърди',
    description: 'Отвори гърдите и предната част на раменете с плавно задържане за 20-30 секунди.',
    imageUrl: '/uploads/exercises/Bench-Press-Muscles-697a20efb33dd.jpg',
    alt: 'Пример за разтягане на гърди след тренировка',
    displayOrder: 1,
  },
  {
    title: 'Разтягане за гръб',
    description: 'Отпусни горната част на гърба и латисимуса, без да пружинираш в крайната позиция.',
    imageUrl: '/uploads/exercises/Bent-over-barbell-row-697a21c86186f.webp',
    alt: 'Пример за разтягане на гръб след тренировка',
    displayOrder: 2,
  },
  {
    title: 'Разтягане за задно бедро',
    description: 'Дръж таза стабилен и дишай спокойно, за да намалиш напрежението в задната верига.',
    imageUrl: '/uploads/exercises/barbell-romanian-deadlift-from-deficit-6977cea99241d.webp',
    alt: 'Пример за разтягане за задно бедро след тренировка',
    displayOrder: 3,
  },
];

function getTrustedHosts(): string[] {
  try {
    return [new URL(API_BASE_URL).host];
  } catch {
    return [];
  }
}

function resolveOverride(): WorkoutStretchingContentItem[] | null {
  const override = (globalThis as StretchingOverrideWindow).__WORKOUT_STRETCHING_CONTENT__;
  return Array.isArray(override) ? override : null;
}

function getSafeStretchingImageUrl(url: string): string | null {
  const trimmedUrl = url.trim();
  if (!trimmedUrl || /^javascript:/i.test(trimmedUrl)) {
    return null;
  }

  if (trimmedUrl.startsWith('/')) {
    return getImageUrl(trimmedUrl);
  }

  try {
    const parsedUrl = new URL(trimmedUrl);
    if (parsedUrl.protocol !== 'https:') {
      return null;
    }

    return getTrustedHosts().includes(parsedUrl.host) ? parsedUrl.toString() : null;
  } catch {
    return null;
  }
}

export function getWorkoutStretchingContent(): ResolvedWorkoutStretchingContentItem[] {
  const source = resolveOverride() ?? WORKOUT_STRETCHING_CONTENT;

  return source
    .filter((item) => (
      typeof item?.title === 'string' &&
      typeof item?.description === 'string' &&
      typeof item?.imageUrl === 'string' &&
      typeof item?.alt === 'string' &&
      typeof item?.displayOrder === 'number'
    ))
    .sort((left, right) => left.displayOrder - right.displayOrder)
    .map((item) => ({
      ...item,
      safeImageUrl: getSafeStretchingImageUrl(item.imageUrl),
    }))
    .filter((item) => item.safeImageUrl !== null);
}
